export default __webpack_public_path__ + "static/media/information--tunnel--g1.03be4883.png";